import en from './locales/en'
export default {
  legacy: false,
  globalInjection: true,
  locale: 'en',
  messages: {
    en,
  },
}
